(ns motorsaif.web.pages.forgot-password
  (:require
   [clojure.string :as str]
   [motorsaif.web.components :as c]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.validation :as validation]
   [motorsaif.web.lib.form :as form]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [motorsaif.log :as log]
   [motorsaif.web.svg :as svg]
   [reagent.core :as r]
   [motorsaif.string :refer [format]]
   [motorsaif.frontend-routes :as routes]))

;; I should stay on the page I am, then invoke the modal.
;; No redirections should happen.



(defn- forgot-password-request [{:keys [all-data]}]
  (let [req {:type :POST
             :url "/api/account/verify-code"
             :params {:data (assoc all-data :context :forgot-password)}
             :id :verify-code
             :handler
             (fn [{:keys [state] :as res}]
               (log/info [:sign-up res])
               (condp = state
                 :validated
                 (js/window.location.reload)
                 :code-invalid
                 (rf/dispatch [:toast {:type "error"
                                       :message "Code invalid"}])))
             :error-handler (fn [res]
                              (rf/dispatch [:toast {:type "error"
                                                    :message "Backend server error"}]))}]
    (rf/dispatch [:do-ajax req])))

(defn verify-code [*state]
  (let [{:keys [email]} @*state
        {:keys [*data *validated-data form-params input radio] :as form-args}
        (form/make-form {:schema validation/verify-code
                          :on-submit {:valid forgot-password-request
                                      :invalid (fn [error]
                                                 (println "Submit error " error))}
                          :init-data
                          {:email email}
                          #_{:user/email (str "naomarik" "@gmail.com")
                             :user/handle "Naomarik"
                             :user/password "hello"
                             }})]
    (fn []
      (when-not email
        (rf/dispatch [:common/navigate! :sign-up]))
      [:div.root-wrap
       [:div.logo.sm svg/logo]
       [:div.container.sm
        [:div
         [:h2 "Verification"]
         [:p.subtitle
          [:span "Your code was sent to"]
          [:div.text.med.bold email]]
         [:form
          form-params
          [:div.code
           [input {:placeholder "Code"
                   :label "Code"
                   :type :number}
            [:nonce]]]
          [input {:placeholder "New password"
                  :label "New Password"
                  :type "password"}
           [:password]]
          [:p.login
           #_[:a {:href (routes/path-for :login)}
              [:span "Did not get an email? "]
              [:span.bold
               "Resend Code"]]]
          [:button.btn.primary.full
           {:type "submit"}
           "Confirm and Login"]]
         ]]])))


(defn- verification-code-request [{:keys [all-data]} *state]
  (let [{:keys [email]} all-data]
    (swap! *state assoc :email email)
    (rf/dispatch
     [:api/request-code
      {:email email
       :context :forgot-password
       :callback
       (fn [res]
         (let [{:keys [success state backoff]} res]
           (swap! *state assoc :response-state state)
           (cond
             success (swap! *state assoc :step :verify-code)
             backoff (swap! *state assoc :backoff backoff))))}]))


  #_(let [{:keys [email]} all-data
          req {:type :POST
               :url "/api/account/request-code"
               :params {:data {:email email
                               :context :forgot-password}}
               :id :forgot-verify-code
               :handler
               (fn [{:keys [state success backoff] :as res}]
                 (log/info [:sign-up res])
                 (condp = state
                   :code-sent
                   (reset! *state  {:step :verify-code
                                    :email email})
                   :no-user
                   (rf/dispatch [:toast {:type "error"
                                         :message (tr
                                                   [:page
                                                    :forgot-password
                                                    :submit
                                                    :email-not-registered])}])))
               :error-handler (fn [res]
                                (rf/dispatch [:toast {:type "error"
                                                      :message
                                                      (tr :forms.general.backend-error)}]))}]
      (rf/dispatch [:do-ajax req])))

(defn forgot-password-form [*state]
  (let [init-data {:email ""}
        {:keys [*data *validated-data form-params input radio] :as form-args}
        (form/make-form {:schema validation/forgot-password
                          :on-submit {:valid #(do
                                                (println "EHEES")
                                                (verification-code-request % *state))
                                      :invalid (fn [error]
                                                 (println "Submit error " error))}
                          :init-data init-data})]
    (fn []
      [:div.root-wrap
       [:div.logo.sm svg/logo]
       [:div.container.sm
        [:div
         [:h2 (tr :page.forgot-password.title)]
         [:p.subtitle
          [:span (tr :page.forgot-password.subtitle)]]
         [:form
          form-params
          [input {:placeholder
                  (tr :page.forgot-password.email-placeholder)} [:email]]
          [:div.input-wrap
           [:button.btn.primary.full
            {:type "submit"}
            (tr :page.forgot-password.submit.button)]]]]]])))



(defn root []
  (let [*state (r/atom {:step :email-input
                        :response-state nil
                        :email nil})
        *user (subscribe [:user])
        ]
    (fn []
      (when @*user
        (rf/dispatch [:common/navigate! :profile]))
      (condp = (:step @*state)
        :email-input [forgot-password-form *state]
        :verify-code [verify-code *state]))))
